import Link from 'next/link'
import { ArrowRight } from '@phosphor-icons/react/dist/ssr'

interface SimpleButtonProps {
  href?: string
  label?: string
  size?: 'sm' | 'md' | 'lg'
  variant?: 'primary' | 'outline' | 'ghost' | 'ghost-dark' | 'midnight' | 'limestone'
  hasIcon?: boolean
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
  onClick?: () => void
  textSwap?: boolean
}

export function SimpleButton({
  href,
  label = 'Learn more',
  size = 'md',
  variant = 'outline',
  hasIcon = false,
  disabled = false,
  type = 'button',
  onClick,
  textSwap = false,
}: SimpleButtonProps) {
  const className = [
    'btn-simple',
    `btn-simple--${size}`,
    `btn-simple--${variant}`,
    hasIcon && 'btn-icon',
    disabled && 'btn-simple--disabled',
    textSwap && 'btn-simple--text-swap',
  ]
    .filter(Boolean)
    .join(' ')

  const content = (
    <>
      {textSwap ? (
        <span className="btn-simple__swap" aria-hidden="false">
          <span className="btn-simple__swap-default">{label}</span>
          <span className="btn-simple__swap-hover" aria-hidden="true">{label}</span>
        </span>
      ) : (
        <span>{label}</span>
      )}
      {hasIcon && <ArrowRight className="btn-icon__arrow" />}
    </>
  )

  if (href && !disabled) {
    return (
      <Link href={href} className={className} onClick={onClick}>
        {content}
      </Link>
    )
  }

  return (
    <button className={className} type={type} onClick={onClick} disabled={disabled}>
      {content}
    </button>
  )
}
